module.exports = "https://la-static.prod-my.games/minigames/collection/img/reward.c86de445.svg";